"use client";
import { useMemo, useState, useCallback } from 'react'

export default function useTruncate(initialText: string | null | undefined, limit: number = 10) {
  const text = initialText ?? ''
  const [expanded, setExpanded] = useState(false)

  const isTruncated = useMemo(() => text.length > limit, [text, limit])

  const displayText = useMemo(() => {
    if (!isTruncated) return text
    return expanded ? text : `${text.slice(0, limit)}...`
  }, [text, limit, expanded, isTruncated])

  const toggle = useCallback(() => setExpanded(v => !v), [])

  return { displayText, isTruncated, expanded, toggle }
}
